import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, Platform, Linking } from 'react-native';
import { Button, Input, Routes, Screen, Line, Text, Checkbox, Colors, Icon } from '../components';
import AuthController from '../controllers/authController';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TouchableOpacity } from 'react-native-web';
import AnimatedCodeInput from "@brainsbeards/react-native-animated-code-input";

function EmptyPage(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    let content = searchParams.get('content');

    let is_successful = content && content.toLowerCase() && content.toLowerCase().includes('success');
    let is_canceled   = content && content.toLowerCase() && content.toLowerCase().includes('cancel');
    let icon_name     = is_successful ? 'check-circle'       : 'exclamation-circle';
        icon_name     = is_canceled   ? 'exclamation-circle' : icon_name;

    return  <View className='flex-container-column' style={{ alignItems: 'center' }}>
      { icon_name ? <View style={{ marginTop: 15, marginBottom: 10 }}>
        <Icon name={ icon_name } solid={true} size={35} />
      </View> : null }
      <Text style={{ fontSize: 18, fontWeight: '500', textAlign: 'center' }}>{ content }</Text>
      <Text style={{ fontSize: 14, textAlign: 'center', color: 'grey', marginTop: 5 }}>Close page to continue</Text>
    </View>
  } else {
    return null;
  }
}

export default EmptyPage
